import * as React from 'react';

import { TabsList } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';

/**
 * The tab row that navigates a page's sections: underlined tabs on a rule that
 * spans the full width. Triggers keep their natural width rather than
 * stretching across the row. Small filter or mode toggles keep the segmented
 * `TabsList` instead.
 */
export function PageTabsList({
  className,
  ...props
}: Omit<React.ComponentProps<typeof TabsList>, 'variant'>): React.ReactElement {
  return (
    <TabsList
      variant="line"
      className={cn('w-full justify-start border-b *:flex-initial', className)}
      {...props}
    />
  );
}
